import * as React from "react";
const SvgSmallarrowright = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 8, viewBox: "0 0 6 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 1L4.5 4L1.5 7", stroke: "currentColor", strokeMiterlimit: 10, strokeLinecap: "square" }));
export default SvgSmallarrowright;
